import Navbar from "@/components/layout/Navbar";
import { Hero } from "@/components/sections/Hero";
import TrustedPartners from "@/components/sections/TrustedPartners";
import { Products } from "@/components/sections/Products";
import Workflow from "@/components/sections/Workflow";
import Features from "@/components/sections/Features";
import Testimonials from "@/components/sections/Testimonials";
import Cities from "@/components/sections/Cities";
import Footer from "@/components/layout/Footer";
import PageLayout from "@/components/layout/PageLayout";

const HomePage = () => {
  // Add a console log to verify the component is being rendered
  console.log("HomePage component rendering");
  
  return (
    <PageLayout showBreadcrumbs={false}>
      <div className="space-y-8">
        <div 
          className="animate-fade-up opacity-0" 
          style={{ animationDelay: '0.2s', animationFillMode: 'forwards' }}
        >
          <Hero />
        </div>
        
        <div 
          className="animate-scale-up opacity-0" 
          style={{ animationDelay: '0.4s', animationFillMode: 'forwards' }}
        >
          <TrustedPartners />
        </div>
        
        <div 
          className="animate-fade-up opacity-0" 
          style={{ animationDelay: '0.6s', animationFillMode: 'forwards' }}
        >
          <Workflow />
        </div>
        
        <div 
          className="animate-scale-up opacity-0" 
          style={{ animationDelay: '0.8s', animationFillMode: 'forwards' }}
        >
          <Products />
        </div>
        
        <div 
          className="animate-fade-up opacity-0" 
          style={{ animationDelay: '1s', animationFillMode: 'forwards' }}
        >
          <Features />
        </div>
        
        <div 
          className="animate-scale-up opacity-0" 
          style={{ animationDelay: '1.2s', animationFillMode: 'forwards' }}
        >
          <Testimonials />
        </div>
        
        <div 
          className="animate-fade-up opacity-0" 
          style={{ animationDelay: '1.4s', animationFillMode: 'forwards' }}
        >
          <Cities />
        </div>
      </div>
    </PageLayout>
  );
};

export default HomePage;